// Fixture loader for the Synthesis Visualizations module.
//
// Source of truth is the interim-skill contract fixture (synthesis.example.json,
// the de-identified "Meridian Auto Care" engagement, all eight tabs populated and
// contract-validated). The platform's synthesis stage emits this same shape, so
// nothing here is throwaway — swapping to the live feed is a data-source change,
// not a component change.

import type { SynthesisPayload } from './types';
import raw from './synthesis.example.json';

export const synthesis = raw as unknown as SynthesisPayload;

export const engagement = synthesis.engagement;
export const sources = synthesis.sources;
export const themes = synthesis.themes;
export const quotes = synthesis.quotes;
export const insights = synthesis.insights;
export const opportunities = synthesis.opportunities;
export const journey = synthesis.journey;
export const mindmap = synthesis.mindmap;
export const workflowArchitecture = synthesis.workflow_architecture;
export const firstPrinciples = synthesis.firstPrinciples;
export const coverage = synthesis.coverage;
export const meta = synthesis.meta;

export const totalQuotes = quotes.length;

export type {
  Engagement, Source, Theme, Quote, Insight, InsightKind, Opportunity, Sizing,
  JourneyStage, MindNode, MindMap, WorkflowArchitecture, Layer, Lane,
  FPStep, FPBlock, CoverageFn, Meta, SevInputs, SevRationale, SynthesisPayload,
} from './types';
